import axios from "axios";
import {
  PLAN,
  BASE_URL,
  PLANS_LIST,
  TENANT_LIST,
  COUNTRY_LIST,
  TENANT_DETAILS,
  PLAN_DETAILS,
  CAMPAIGNS_LIST,
  SUBUSER_LIST,
  PAYMENT_LIST,
  PLAN_WISE_USERS,
  CHANGE_TENANT_STATUS,
  REGENERATE_INVOICE,
  DOWNLOAD_INVOICE,
  EMAIL_CONFIG_LIST,
  CAMPAIGNS_DETAILS,
  ATTENDEE_LIST,
  REDIRECT_LINKS,
  TENANT_ACCOUNT_TYPE,
  ADD_CREDITS,
  CAMPAIGN_LOG,
  CREDITS_LIST,
  ADD_ADMIN_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  VERIFY_UUID,
  ADD_NOTE,
  ADMIN_CAMPAIGNS_LIST,
  LIST_PAYMENT_HISTORY,
  ADMIN_USER_LIST,
  RESET_PASSWORD_PROFILE,
  NOTE_LIST,
  CREATE_CUSTOM_PLAN,
  GET_TENANT_CUSTOM_PLAN,
  ACTIVATE_CUSTOM_OFFLINE_PLAN,
  DELETE_CUSTOM_PLAN,
  CANCELLED_SUBSCRIPTION_LIST,
  UPCOMING_RENEWALS,
  TENANT_STATUS,
  CANCEL_TENANT_SUBSCRIPTION,
  UPDATE_PLAN_END_DATE,
  GRAPH_DATA,
  MARK_CAMPAIGN_RETRY,
} from "./apiConstants";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

//To download invoice pdf, needs to pass responseType and headers
const API_FOR_PFD = axios.create({
  baseURL: BASE_URL,
  responseType: "arraybuffer",
  headers: {
    "Content-Type": "application/pdf",
  },
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

API_FOR_PFD.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

//All plan related APIs
export const add_plan = (planData) => API.post(`${PLAN}`, planData);

export const get_plan = (planid) => API.get(`${PLAN}/${planid}`);

export const get_plans_list = (filters) =>
  API.get(`${PLANS_LIST}${filters ? filters : ""}`);

export const update_plan = (planID, planUpdatedData) =>
  API.patch(`${PLAN}/${planID}`, planUpdatedData);

export const get_plan_wise_users = () => API.get(`${PLAN_WISE_USERS}`);

//All tenant related APIs
export const get_tenant_list = (query, num, sort) =>
  API.get(
    `${TENANT_LIST}?${
      query && `filtersJSON=${query}`
    }&page=${num}&sortOptionJSON=${sort}`,
  );

export const change_account_type = (id, body) =>
  API.patch(`${TENANT_ACCOUNT_TYPE}/${id}`, body); //To change the account type of tenant

export const patch_tenant_details = (id, body) =>
  API.patch(`${TENANT_DETAILS}/${id}`, body);

export const change_tenant_status = (id, status) =>
  API.patch(`${CHANGE_TENANT_STATUS}/${id}`, status);

export const delete_tenant = (id) =>
  API.delete(`${CHANGE_TENANT_STATUS}/${id}`);

//All tenant details related APIs
export const get_tenant_details = (id) => API.get(`${TENANT_DETAILS}/${id}`);

export const get_tenant_plan_details = (id) => API.get(`${PLAN_DETAILS}/${id}`);

export const get_campaign_list = (id, filter, pageNum, sort) =>
  API.get(
    `${CAMPAIGNS_LIST}/${id}?${
      filter && `filtersJSON=${filter}`
    }&page=${pageNum}${sort}`,
  );

export const get_subuser_list = (id, filter, pageNum, sort) =>
  API.get(
    `${SUBUSER_LIST}/${id}?filtersJSON=${filter}&page=${pageNum}&sortOptionJSON=${sort}`,
  );

export const get_payment_list = (id, pageNum, filter) => {
  const url = filter
    ? `${PAYMENT_LIST}?tenantID=${id}&page=${pageNum}&filtersJSON=${filter}`
    : `${PAYMENT_LIST}?tenantID=${id}&page=${pageNum}`;
  return API.get(url);
};

export const regenerate_invoice = (invoiceID) =>
  API.get(`${REGENERATE_INVOICE}/${invoiceID}`);

export const download_invoice = (invoiceID, tenantID) =>
  API_FOR_PFD.get(`${DOWNLOAD_INVOICE}/${invoiceID}?tenantID=${tenantID}`);

export const get_email_config_list = (tenantID) =>
  API.get(`${EMAIL_CONFIG_LIST}?tenantID=${tenantID}`);

export const add_credits = (creditsData) =>
  API.post(`${ADD_CREDITS}`, creditsData);

export const get_credits_list = (tenantID, pageNum) =>
  API.get(`${CREDITS_LIST}?id=${tenantID}&page=${pageNum}`);

//Redirect Links API
export const redirect_links = (pageNum, filter) =>
  API.get(`${REDIRECT_LINKS}?page=${pageNum}&filtersJSON=${filter}`);

//Others
export const get_country_list = () => API.get(`${COUNTRY_LIST}`);

//campaign Details
export const campaign_details = (campaignCode, tenantID) =>
  API.get(`${CAMPAIGNS_DETAILS}${campaignCode}?tenantID=${tenantID}`);
export const campaign_logs = (campaignCode, tenantID) =>
  API.get(`${CAMPAIGN_LOG}${campaignCode}?tenantID=${tenantID}`);

export const mark_campaign_retry = (campaignCode, tenantID) =>
  API.patch(`${MARK_CAMPAIGN_RETRY}${campaignCode}`);

//attendee list
export const attendee_list = (
  campaignCode,
  tenantID,
  pageNo,
  filter,
  sortParam,
) =>
  API.get(
    `${ATTENDEE_LIST}${campaignCode}?tenantID=${tenantID}&page=${pageNo}${
      filter ? filter : ""
    }${sortParam ? sortParam : ""}`,
  );

//Add Admin User API
export const add_admin_user = (userData) =>
  API.post(`${ADD_ADMIN_USER}`, userData);

//reset password Api
export const forget_password = (email) => API.post(`${FORGOT_PASSWORD}`, email);
export const reset_password = (data) => API.post(`${RESET_PASSWORD}`, data);

//Verify email for forgot password and register sub user
export const verify_uuid = (uuid) => API.get(`${VERIFY_UUID}${uuid}`);

export const reset_profile_password = (passwords) =>
  API.patch(`${RESET_PASSWORD_PROFILE}`, passwords);
//admin campaigns list
export const get_admin_campaign_list = (status, pageNum) =>
  API.get(
    `${ADMIN_CAMPAIGNS_LIST}?${status && `status=${status}&`}page=${pageNum}`,
  );

//admin payment list api
export const list_payment_history = (status, pageNum) =>
  API.get(
    `${LIST_PAYMENT_HISTORY}?${status && `status=${status}&`}page=${pageNum}`,
  );

// add note API
export const add_note = (note, tenantID) =>
  API.post(`${ADD_NOTE}${tenantID}`, note);

//admin user list api code
export const admin_user_list = (pageNum) =>
  API.get(`${ADMIN_USER_LIST}?page=${pageNum}`);

export const note_list = (tenantID, pageNum) =>
  API.get(`${NOTE_LIST}/${tenantID}?page=${pageNum}`);

//create custom plan
export const create_custom_plan = (bodyData) =>
  API.post(CREATE_CUSTOM_PLAN, bodyData);

//get custom plan details
export const get_tenant_custom_plan = (querryParams) =>
  API.get(`${GET_TENANT_CUSTOM_PLAN}${querryParams}`);

//activate offline plan
export const activate_custom_offline_plan = (bodyData) =>
  API.post(ACTIVATE_CUSTOM_OFFLINE_PLAN, bodyData);

//delete custom plan
export const delete_custom_plan = (querryParams) =>
  API.delete(`${DELETE_CUSTOM_PLAN}${querryParams}`);

export const upcoming_renewals = (filter, pageNum) =>
  API.get(
    `${UPCOMING_RENEWALS}?page=${pageNum}${`&filtersJSON=${filter}` || ""}`,
  );

export const cancelled_sub_list = (filter, pageNum, sort) =>
  API.get(
    `${CANCELLED_SUBSCRIPTION_LIST}?page=${pageNum}${
      `&filtersJSON=${filter}` || ""
    }&sortOptionJSON=${sort}`,
  );
export const change_status = (id, body) =>
  API.patch(`${TENANT_STATUS}${id}`, body);

export const cancel_tenant_subscription = (tenantId, cancellationReason) =>
  API.post(`${CANCEL_TENANT_SUBSCRIPTION}/${tenantId}`, cancellationReason);

export const update_tenant_plan_end_date = (tenantId, data) =>
  API.patch(`${UPDATE_PLAN_END_DATE}/${tenantId}`, data);

//graph data API
export const get_graph_data = (filter) => {
  return API.get(GRAPH_DATA, {
    params: {
      type: filter.type,
      startDate: filter.startDate,
      endDate: filter.endDate,
      ...(filter.tenantID && { tenantID: filter.tenantID }),
    },
  });
};
